import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../api/translate.service';

@Pipe({
  name: 'ivRentRateLabelFn'
})
export class RentRateLabelFnPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }
  transform(rentrate: string): string {
    return rentrate === 'Annual Rate' ?
      this.translateService.getTranslation('ANNUAL') : this.translateService.getTranslation('MONTHLY');
  }
}
